"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ElementIds_1 = require("../../enums/ElementIds");
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
function formatPhoneNumber(phone) {
    var _a;
    const phoneNumber = (_a = phone === null || phone === void 0 ? void 0 : phone.replace(/\D/g, '')) !== null && _a !== void 0 ? _a : '';
    if (phoneNumber.length > 10)
        return phoneNumber;
    var x = /(\d{0,3})(\d{0,3})(\d{0,4})/.exec(phoneNumber);
    if (!x)
        return phone;
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}
exports.default = vue_1.default.extend({
    name: 'update-business',
    data() {
        var _a;
        let challenge = this.$store.state.currentChallenge;
        return {
            businessName: challenge.BusinessName,
            businessPhone: formatPhoneNumber(challenge.BusinessPhoneNumber),
            businessPhoneType: [(_a = challenge.BusinessPhoneType) !== null && _a !== void 0 ? _a : 'Work'],
            businessAddressLine1: challenge.BusinessAddressLine1,
            businessAddressLine2: challenge.BusinessAddressLine2,
            businessCity: challenge.BusinessCity,
            businessState: challenge.BusinessState,
            businessZip: challenge.BusinessPostalCode,
            businessEin: challenge.BusinessEin,
            hasPhoneError: false,
            hasZipError: false,
            hasEinError: false,
            phoneTypes: [
                { label: this.getSiteText('Registration.UpdateBusiness.PhoneTypes.Home'), value: 'Home' },
                { label: this.getSiteText('Registration.UpdateBusiness.PhoneTypes.Mobile'), value: 'Mobile' },
                { label: this.getSiteText('Registration.UpdateBusiness.PhoneTypes.Work'), value: 'Work' },
            ],
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        async submitForm() {
            if (this.submitting) {
                return;
            }
            void userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                stepType: userTelemetry_1.stepType.progression,
                stepName: userTelemetry_1.stepName.business_information,
                action: userTelemetry_1.userAction.continue_clicked,
            });
            const challenge = {
                ...this.updateBusinessChallenge,
                BusinessName: this.businessName,
                BusinessPhoneNumber: this.businessPhone.replace(/\D/g, ''),
                BusinessPhoneType: this.businessPhoneType[0],
                BusinessAddressLine1: this.businessAddressLine1,
                BusinessAddressLine2: this.businessAddressLine2,
                BusinessCity: this.businessCity,
                BusinessState: this.businessState,
                BusinessPostalCode: this.businessZip,
                BusinessEin: this.businessEin.replace(/\D/g, ''),
            };
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
        },
        validatePhone() {
            let formattedPhone = formatPhoneNumber(this.businessPhone);
            this.businessPhone = formattedPhone !== null && formattedPhone !== void 0 ? formattedPhone : this.businessPhone;
            this.hasPhoneError = !(formattedPhone.replace(/\D/g, '').length >= 10);
        },
        validateZip() {
            this.hasZipError = this.zipCodeRegex().exec(this.businessZip) === null;
        },
        validateEin() {
            var _a;
            this.hasEinError = ((_a = this.businessEin) !== null && _a !== void 0 ? _a : '').replace(/\D/g, '').length !== 9;
        },
        zipCodeRegex() {
            return /^\d{5}([-]|\s*)?(\d{4})?$/;
        },
        getCustomErrorMessage(val) {
            return this.getSiteText('UserIdentifyingField.Required', this.getSiteText(`UserIdentifyingField.${val}.Label`));
        },
    },
    computed: {
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        getSubheading() {
            return this.getSiteText('Registration.UpdateBusiness.Subheading');
        },
        getPhoneTypeSiteText() {
            return { 'label': this.getSiteText('Registration.UpdateBusiness.Input.BusinessPhoneType') };
        },
        buttonDisabled() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const isValidState = ((_b = (_a = this.businessName) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0
                && ((_d = (_c = this.businessAddressLine1) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0
                && ((_f = (_e = this.businessCity) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0
                && this.businessState
                && this.zipCodeRegex().exec(this.businessZip) !== null
                && ((_h = (_g = this.businessPhone) === null || _g === void 0 ? void 0 : _g.replace(/\D/g, '').length) !== null && _h !== void 0 ? _h : 0) >= 10
                && this.businessPhoneType;
            return !isValidState;
        },
        updateBusinessChallenge() {
            return this.$store.state.currentChallenge;
        },
        zipHasErrorCheck() {
            return this.hasZipError;
        },
        einHasErrorCheck() {
            return this.hasEinError;
        },
        phoneHasErrorCheck() {
            return this.hasPhoneError;
        },
        getZipErrorMessage() {
            return this.hasZipError ? [this.getSiteText('Registration.UpdateBusiness.Errors.Zip')] : [];
        },
        getPhoneErrorMessage() {
            return this.hasPhoneError ? [this.getSiteText('Registration.UpdateBusiness.Errors.Phone')] : [];
        },
        getEinErrorMessage() {
            return this.hasEinError ? [this.getSiteText('Registration.UpdateBusiness.Errors.Ein')] : [];
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
